var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['component-view-carregando', _vm.modo, { 'img-small': _vm.imgSmall }]},[_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }